module.exports = __webpack_public_path__ + "media/images/setinha-baixo-a411b148c856d203e45f0cb9ee9d3778.svg";